import React from "react";

const Loader = () => {
  return (
    <div id="ploader">
      <div className="loader-content">
        <div className="loader-page"></div>
      </div>
    </div>
  );
};

export default Loader;
